import CryptoJS from 'crypto-js';

const STORAGE_KEY = 'portfolio_secure_data';
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'UnaClaveDe32BitsParaEncriptacion===';

interface SecureData {
  token?: string;
  user?: any;
  language?: string;
  [key: string]: any;
}

/**
 * Encripta datos para almacenamiento seguro
 */
const encrypt = (data: string): string => {
  return CryptoJS.AES.encrypt(data, ENCRYPTION_KEY).toString();
};

/**
 * Desencripta datos del almacenamiento seguro
 */
const decrypt = (encryptedData: string): string => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

/**
 * Obtiene todos los datos almacenados de forma segura
 */
export const getSecureStorage = (): SecureData => {
  try {
    const encryptedData = sessionStorage.getItem(STORAGE_KEY);
    if (!encryptedData) {
      return {};
    }
    
    const decryptedData = decrypt(encryptedData);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Error al desencriptar datos:', error);
    return {};
  }
};

/**
 * Guarda datos de forma segura
 */
export const setSecureStorage = (data: Partial<SecureData>): void => {
  try {
    const currentData = getSecureStorage();
    const newData = { ...currentData, ...data };
    const encryptedData = encrypt(JSON.stringify(newData));
    sessionStorage.setItem(STORAGE_KEY, encryptedData);
  } catch (error) {
    console.error('Error al encriptar datos:', error);
  }
};

/**
 * Elimina un campo específico del almacenamiento seguro
 */
export const removeSecureStorage = (key: keyof SecureData): void => {
  try {
    const currentData = getSecureStorage();
    delete currentData[key];
    const encryptedData = encrypt(JSON.stringify(currentData));
    sessionStorage.setItem(STORAGE_KEY, encryptedData);
  } catch (error) {
    console.error('Error al eliminar dato:', error);
  }
};

/**
 * Limpia todo el almacenamiento seguro
 */
export const clearSecureStorage = (): void => {
  sessionStorage.removeItem(STORAGE_KEY);
};

/**
 * Obtiene un valor específico del almacenamiento seguro
 */
export const getSecureItem = <T = any>(key: keyof SecureData): T | null => {
  const data = getSecureStorage();
  return (data[key] as T) || null;
};

/**
 * Guarda un valor específico en el almacenamiento seguro
 */
export const setSecureItem = <T = any>(key: keyof SecureData, value: T): void => {
  setSecureStorage({ [key]: value });
};

